import React from 'react';
import classnames from 'classnames';
import SvgIcon from '@material-ui/core/SvgIcon';

const DrawPencil = ({ className, ...props }) => (
  <SvgIcon
    width="16"
    height="14"
    viewBox="0 0 15 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={classnames({
      icon: true,
      [className]: !!className
    })}
    {...props}
  >
    <g clipPath="url(#clip0_8718_19562)">
      <path
        d="M9.87746 2.58495L0.596396 11.8648L0.0101579 15.2222C-0.0689031 15.675 0.325464 16.0694 0.77858 15.9897L4.13633 15.4009L13.4149 6.12207L9.87746 2.58495ZM15.5602 3.97648C16.1461 3.39025 16.1461 2.43995 15.5602 1.85371L14.1458 0.439679C13.5596 -0.14656 12.609 -0.14656 12.0227 0.439679L10.5843 1.87778L14.1218 5.41521L15.5602 3.97648V3.97648ZM14.2733 12.2382C14.0674 12.2382 13.8908 12.1204 13.8174 11.9263C13.2508 10.4332 12.3049 9.88324 11.2346 9.71669L8.05719 12.8941C8.33249 14.8735 9.85684 16 11.9999 16C14.8146 16 15.9998 13.7382 15.9998 11.1648C15.6939 11.3735 14.6205 12.2382 14.2733 12.2382V12.2382ZM3.75571 7.29142L6.75003 4.29742L4.56288 1.03467C2.62667 -1.72778 -1.6295 1.64153 0.658895 4.15617L3.75571 7.29142V7.29142Z"
        fill="#FC2472"
      />
    </g>
    <defs>
      <clipPath id="clip0_8718_19562">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export default DrawPencil;
